import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const PageTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 26px;
  @media ${device.mobileMin} {
    margin-bottom: 24px;
  }
`

export const PageTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: ${colors.mainText};
`

export const BackButton = styled.div`
  display: none;
  @media ${device.mobileMin} {
    display: flex;
    align-items: center;
    padding-right: 22px;
    padding-left: 14px;
    width: 48px;
    height: 12px;
    cursor: pointer;
  }
`
